import { Typography } from "@mui/material";
import { CoreModal } from "@verity/components/core";
import styles from "./assessment-in-progress-modal.module.css";

export default function AssessmentInProgressModal({
	onClose,
	title,
	body,
}: {
	onClose: () => void;
	title: string;
	body: string;
}) {
	return (
		<CoreModal
			open
			onClose={onClose}
			title={title}
			minWidth="min(450px, 50%)"
			maxWidth="min(450px, 50%)"
			footerVerticalPadding={"10px"}
			buttons={[
				{
					text: "Close",
					color: "secondary",
					onClick: onClose,
				},
			]}
		>
			<Typography className={styles.body}>{body}</Typography>
		</CoreModal>
	);
}
